import terminal from './terminal';
export default {
  // SSH
  ...terminal,

  // device
  device_title: '设备',

  // tab
  device_tab1: '设备详情',
  device_tab2: '远程操作',
  device_tab3: '问题',

  // table
  device_table_current_value: '当前值',
  device_table_set_value: '设置值',
  device_table_refresh_time: '最后刷新时间',
  device_table_status: '状态',
  device_table_sn: 'SN',
  device_table_name: '设备名称',
  device_table_model: '设备模型',
  device_table_soft_version: '软件版本',
  device_table_maintainace: '未维护时长',
  device_table_maintainace_last_time: '最后维护时间',
  device_table_belonged_site: '隶属站点',
  device_table_install_date: '安装日期',
  device_table_maintenance_duration: '维护周期',
  device_table_unmaintained_time: '未维护时长',
  device_table_total_runtime: '总运行时长',
  device_table_export: '导出设备数据',
  device_table_export_description: '将导出所有列表的所有设备（如果搜索条件不为空，则导出搜索结果）',
  device_table_export_loading: '导出中，请稍等...',
  device_table_export_message: '导出失败',
  device_table_import: '导入设备',
  device_table_import_description: '请上传需要导入的文件',
  device_table_import_download: '下载导入模板',
  device_table_import_loading: '导入中，请稍等...',
  device_table_import_message: '必须至少选择一个文件',
  device_table_status_info_title: '设备状态说明',
  device_table_status_info_content: [
    {
      status: '离线',
      description: '设备离线',
    },
    {
      status: '空闲',
      description: '设备空闲',
    },
    {
      status: '运行中',
      description: '设备正在运行',
    },
    {
      status: '报错',
      description: '设备报错',
    },
    {
      status: '维护',
      description: '设备维护中',
    },
    {
      status: '固件更新',
      description: '设备正在更新固件',
    },
    {
      status: '禁用',
      description: '设备已禁用',
    },
    {
      status: '固件更新',
      description: '设备正在更新固件',
    },
  ],
  device_table_fault_name: '错误类型',

  // control
  device_control_type: '控制类型',
  device_control_remote_title: '远程控制设备',
  device_control_remote_tip: '注：仅支持同一站点，且支持批量操作的设备。',
  // control
  device_control_remote: '远程控制',
  device_control_text: '控制',

  // form
  device_form_select_device: '选择设备',
  device_form_select_type: '选择一个设备',
  device_form_param1: '请输入第一个参数',
  device_form_param1_ftp: '选择附件',
  device_form_param2: '请输入第二个参数',
  device_form_name_placeholder: '请输入设备名称',
  device_form_sn_placeholder: '请输入设备SN',
  device_form_sn_format_error: 'SN格式错误',
  device_form_arrive_date_placeholder: '请选择设备出厂日期',
  device_form_install_date_placeholder: '请选择设备安装日期',
  device_form_maintenance_duration_placeholder: '请输入维护周期',
  device_form_maintenance_duration_unit: '单位：天',
  device_form_select_model_placeholder: '请选择设备模型',
  device_form_icons: '设备图片',
  device_form_model_extra:
    '注：可先选择一个统一的设备模型，若所选设备模型与实际不符后续可进行修改。',
  device_form_import_batch_error: '导入数据为空,请检查导入文件格式是否正确',
  device_form_import_batch_failed: '导入失败',
  device_form_import_batch_success: '导入成功',
  device_form_import_name_error: '设备名称重复',
  device_form_import_sns_error: '设备SN重复',

  device_search_customer_label: '客户',
  device_search_site_label: '站点',
  device_search_site_placeholder: '所有站点',
  device_search_site_placeholder2: '请选择一个站点',
  device_search_keyword_placeholder: '请输入搜索关键字，如名称/SN/软件版本',
  device_search_model_label: '设备模型',
  device_search_model_placeholder: '所有设备模型',
  device_search_model_search_placeholder: '请输入模型名称',

  // msg
  device_msg_busy: '该设备繁忙，请稍等再试',
  device_msg_some_busy: '一些设备繁忙，请稍候再试',
  device_msg_import_file_error: '上传文件格式错误，仅支持JSON文件',
  device_msg_set_timeout: '设置超时',
  deivce_msg_exec_timeout: '执行命令超时',
  device_msg_same_value_error: '不能为相同的值',

  // confirm
  device_confirm_close_vpn_title: '确定关闭VPN?',
  device_confirm_close_vpn_content: '所有依赖VPN的连接将会被断开，如WEBUI、SSH',
  device_confirm_disabled_title: '确定禁用该设备?',
  device_confirm_disabled_confirm:
    '确定禁用后，该设备将与MBE断开连接，在启用之前无法继续使用MBE监控该设备',
  device_confirm_disabled_multi_title: '确定禁用这些设备?',
  device_confirm_disabled_content: '设备名称: {DeviceName}',
  device_confirm_eanbled_title: '确定启用该设备?',
  device_confirm_eanbled_content: '设备名称: {DeviceName}',
  device_confirm_delete_title: '确定删除该设备?',
  device_confirm_delete_confirm: '确定删除后，该设备将从MBE上删除，并且无法继续使用MBE监控该设备',
  device_confirm_command_excute_title: '确定执行该命令?',
  device_confirm_save: 'SN非常重要，保存前请再次检查确认!',
  device_confirm_save_title: '保存再次确认',
  device_confirm_maintain_title: '维护该设备',
  device_confirm_maintain_content: '设备维护后，设备的未维护时长将重置为0',
  device_confirm_maintain_content2: '处理后，该设备的未维护时间将置为0',
  device_confirm_maintain_content3: '处理后，所有未处理的设备的未维护时间将置为0',

  // refresh
  device_refresh_last_by: '刷新：',

  // base info
  device_base_model_title: '设备模型',
  device_base_info_title: '基础信息',
  device_base_info_alarm: '告警',
  device_base_info_alarm_status: '告警状态',
  device_base_info_model: '设备模型',
  device_base_info_arrival_date: '出厂日期',
  device_base_info_create_date_time: '创建时间',

  // config
  device_config_title: '设备配置',
  device_config_previous_value: '上一次的值',

  device_detail_image: '设备图片',

  device_side_title: '设备',
  device_side_run: '运行信息',
  device_side_config: '配置信息',
  device_side_fault: '故障列表',
  device_side_logs: '设备记录',
  device_side_data_chart: '数据图表',

  // 告警类型
  device_alarm_type_ca: 'CA',
  device_alarm_type_ma: 'MA',
  device_alarm_type_oa: 'OA',
  device_alarm_level: '告警级别',
  device_alarm_name: '名称',
  device_alarm_time: '开始时间',
  device_alarm_src: '来源',

  // 状态
  device_status_all: '所有设备',
  device_status_offline: '离线',
  device_status_idle: '空闲',
  device_status_working: '运行中',
  device_status_faulted: '报错',
  device_status_maintain: '维护',
  device_status_firewareupdt: '固件更新',
  device_status_disabled: '禁用',
  device_status_update: '固件更新',

  // 设备命令执行结果错误
  // 执行命令结果，1表示pending，2表示成功，3表示失败，4表示超时，5表示离线
  device_control_excute_result_error_list: {
    1: '等待',
    2: '成功',
    3: '失败',
    4: '超时',
    5: '离线',
  },

  // control log type
  device_control_log_type: {
    1: '软重启',
    2: '硬重启',
    3: '禁用系统',
    4: '禁用连接器',
    5: 'FTP软件升级',
    6: 'FTP日志上传',
    7: 'VPN启动',
    8: 'VPN停止',
    9: '刷新配置',
    10: '刷新参数',
    11: '设置参数',
  },

  device_control_form_ctrlid_error: '请选择一个命令',

  // export
  device_export_title: '导出配置信息',
  device_export_name: '文件名',
  device_export_name_placeholder: '请输入文件名',
  device_export_config_title: '导出运行信息',
  device_export_params_all: '导出所有配置信息?',
  device_export_detail_base: '设备基础信息',
  device_export_detail_alarm: '设备告警信息',
  device_export_detail_runconfig: '设备运行信息',
  device_export_detail_params: '设备配置信息',

  // select model
  device_selectModel_title: '选择设备模型',
  device_selectModel_name_label: '设备模型',
  device_selectModel_image_label: '模型图片',
  device_selectModel_error: '该模型不可选择',

  // params
  device_params_title: '配置信息',
  device_params_set_title: '设置参数',
  device_params_set_select_label: '选择设备',
  device_params_set_select_add_device: '添加设备',
  device_params_logs: '配置日志',
  device_params_batch_set: '批量设置',
  device_params_table_name: '配置项',
  device_params_table_prevalue: '原始值',
  device_params_table_value: '改后值',

  // vpn
  device_vpn_url_label: 'URL',
  device_vpn_dynamic_password: '动态密码',
  device_vpn_remaining_time: '剩余时间',
  device_vpn_period: '有效期',
  device_vpn_period_placeholder: '选择一个有效期',
  device_vpn_period_required_msg: '请选择一个有效期',
  device_vpn_destroy_url: '销毁 URL',
  device_vpn_destroy_url_success: '销毁成功',
  device_vpn_destroy_url_failed: '销毁失败',
  device_vpn_ssh: 'SSH',
  device_vpn_webui: 'WEBUI',
  device_vpn_webui_open: '打开链接',
  device_vpn_destroy_ssh: '销毁 SSH',
  device_vpn_open_ssh: '打开 SSH',
  device_vpn_ssh_connect_title: 'SSH 连接',
  device_vpn_ssh_create_title: '创建 SSH 连接',
  device_vpn_webui_connect_title: '远程设备WEB链接',
  device_vpn_webui_create_title: '创建一个WEB链接',
  device_vpn_not_support_error: '设备不支持远程链接',
  device_vpn_not_support: '设备不支持VPN',
  device_vpn_connect_failed: 'VPN连接失败',
  device_vpn_connect_executing_timeout: '设备执行超时',
  device_vpn_connect_device_disable: '设备已禁用',
  device_vpn_connect_device_offline: '设备已离线',
  device_vpn_error: 'VPN报错，状态码：{status}',

  // logs
  device_operation_log_title: '操作日志',
  device_ctrl_log_title: '控制记录',
  device_params_log_title: '配置记录',
  device_params_change_log_title: '配置项变化',

  // chart
  device_alarm_fault_chart_title: '告警和故障统计',
  device_traffic_history_chart_title: '历史流量统计',
  device_fault_ranking_chart_title: '故障排行',

  device_name_copy: '复制设备名称',
};
